/** @format */

import React from 'react'
import { NavLink } from 'react-router-dom'

import studentIcon from 'assets/icons/student.svg'

import styles from './Navigation.module.scss'

export const Navigation = () => {
  return (
    <div className={styles.wrapper}>
      <nav className={styles.nav}>
        <NavLink className={styles.link} to="/">
          Home
        </NavLink>
        <NavLink className={styles.link} to="/suggestions">
          Suggestions
        </NavLink>
        <NavLink className={styles.link} to="/vacancies">
          Vacancies
        </NavLink>
        <NavLink className={styles.link} to="/about">
          About
        </NavLink>
      </nav>
      <NavLink to="/sign">
        <img className={styles.profileIcon} src={studentIcon} alt="Profile" />
      </NavLink>
    </div>
  )
}
